<template>
  <div>
    <v-card flat class="mt-4 rounded-20" v-if="fullmode">
      <v-card-title class="title-font">
        ORDER FORM
        <v-chip
          v-if="selectedOrderSession.is_photogrammetry"
          small
          color="primary"
          class="rounded-10 mx-2"
        >
          Photogrammetry
        </v-chip>
      </v-card-title>
    </v-card>

    <v-card flat :class="{ 'rounded-20': true, 'mt-4': fullmode }">
      <v-card-title class="title-font pb-0" v-if="!fullmode">
        ORDER FORM
        <v-chip
          v-if="selectedOrderSession.is_photogrammetry"
          small
          color="primary"
          class="rounded-10 mx-2"
        >
          Photogrammetry
        </v-chip>
        <v-spacer />
        <v-tooltip top class="rounded-10">
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="$emit('fullmode')" icon v-bind="attrs" v-on="on">
              <v-icon> mdi-arrow-expand-all </v-icon>
            </v-btn>
          </template>
          <span>Expand Order Form</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text>
        <div
          class="text-center mt-5"
          v-if="selectedOrderSession.responses.length === 0"
        >
          <v-icon class="mr-2">mdi-information</v-icon>
          There is no order form associated with this session.
        </div>
        <v-list v-if="selectedOrderSession.responses.length > 0">
          <v-list-item
            two-line
            v-for="(question, index) in selectedOrderSession.responses"
            :key="index"
          >
            <v-list-item-content>
              <v-list-item-title>{{
                question.name.toUpperCase()
              }}</v-list-item-title>
              <v-list-item-subtitle
                v-if="question.widget !== 'tooth_picker'"
                class="font-weight-bold black--text"
              >
                {{ question.value ? question.value : "-" }}
              </v-list-item-subtitle>
              <ToothPicker
                v-if="question.widget === 'tooth_picker' && teeth"
                v-model="teeth"
                :interactive="false"
                style="max-height: 300px"
              />
              <v-simple-table
                dense
                v-if="
                  question.widget === 'tooth_picker' &&
                  question.value.length > 0
                "
              >
                <thead>
                  <tr>
                    <th>Tooth</th>
                    <th>Implant Platform</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(tooth, index) in question.value" :key="index">
                    <td>{{ tooth.tooth }}</td>
                    <td>{{ tooth.implant_platform.name }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import ToothPicker from "@/components/shared/ToothPicker"

export default {
  name: "OrderForm",

  props: ["fullmode"],

  components: { ToothPicker },

  computed: {
    ...mapGetters(["selectedOrderSession"]),

    teeth() {
      return (
        this.selectedOrderSession.responses
          .find((item) => item.widget === "tooth_picker")
          ?.value?.map((item) => item.tooth) || []
      )
    }
  }
}
</script>
